export const routes = [
  {
    name: 'person_list',
    path: '/person',
    componentConfig: [
      {
        component: 'EndpointListContainer',
        props: {
          endpoint: 'person',
          slice: 'person/person/list',
          selectAction: {
            preview: {
              meta: {
                modal: {
                  body: [
                    {
                      component: 'PersonDetailContainer'
                    }
                  ]
                }
              }
            },
            edit: {
              type: 'person/person/edit/start',
              meta: {
                modal: {
                  title: 'person.actions.update',
                  body: [
                    {
                      component: 'PersonEditForm'
                    }
                  ]
                }
              }
            }
          }
        },
        children: [
          {
            component: 'Grid',
            props: {
              title: 'person.module.name',
              icon: 'licencse',
              config: {
                columns: {
                  id: {
                    label: 'person.entity.id',
                    width: '90px'
                  },
                  company: {
                    label: 'person.entity.company',
                    display: {
                      type: 'objectProps',
                      props: ['name']
                    }
                  },
                  firstName: {
                    label: 'person.entity.firstName'
                  },
                  lastName: {
                    label: 'person.entity.lastName'
                  },
                  email: {
                    label: 'person.entity.email'
                  },
                  phone: {
                    label: 'person.entity.phone'
                  },
                  state: {
                    label: 'person.entity.state',
                    display: {
                      type: 'objectProps',
                      props: ['label']
                    }
                  },
                  updatedAt: {
                    label: 'person.entity.updatedAt',
                    display: {
                      type: 'relativeDate'
                    }
                  }
                },
                filtersConfig: [
                  {
                    label: 'person.filter.state',
                    property: 'state',
                    type: 'eq',
                    inputConfig: {
                      name: 'state',
                      type: 'endpointCombo',
                      endpoint: 'personState',
                      slice: 'person/personState/combo',
                      placeholder: '--',
                      displayField: 'label'
                    },
                    defaultValue: 1 // Hardcoded but i have no clue how to avoid it
                  },
                  {
                    label: 'person.filter.company',
                    property: 'company',
                    type: 'eq',
                    inputConfig: {
                      name: 'company',
                      type: 'wideEndpointCombo',
                      endpoint: 'companyCombo',
                      slice: 'cost/company/combo',
                      displayField: 'name'
                    }
                  },
                  {
                    label: 'person.filter.search',
                    property: 'search',
                    type: 'contains',
                    inputConfig: {
                      name: 'search',
                      type: 'text'
                    }
                  }
                ],
                actions: [
                  {
                    label: 'person.actions.create',
                    type: 'create',
                    icon: 'plus',
                    action: {
                      type: 'person/person/edit/start',
                      meta: {
                        modal: {
                          title: 'person.create',
                          body: [
                            {
                              component: 'PersonCreateForm'
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                recordActions: [
                  {
                    label: '',
                    type: 'edit',
                    icon: 'pen',
                    action: {
                      type: 'person/person/edit/start',
                      meta: {
                        modal: {
                          title: 'person.update',
                          body: [
                            {
                              component: 'PersonEditForm'
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    label: '',
                    type: 'delete',
                    icon: 'trash',
                    action: {
                      type: 'person/person/list/delete',
                      meta: {
                        API: {
                          endpoint: 'person',
                          operation: 'delete'
                        },
                        confirm: {
                          props: {
                            title: 'ims.confirm.delete.title',
                            message: 'ims.confirm.delete.message',
                            confirmText: 'ims.confirm.delete.confirmText',
                            cancelText: 'ims.confirm.delete.cancelText'
                          },
                          confirmed: false
                        }
                      }
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    ],
    exact: true,
    global: true,
    section: true,
    module: 'person',
    label: 'person.module.name',
    icon: 'licencse'
  }
];
